import * as runnersApi from "app/api/runnersApi";
import BackButton from "app/components/BackButton/BackButton";
import { IconBetDrawer } from "app/components/Icon/Icon";
import ScrollToTop from "app/components/ScrollToTop/ScrollToTop";
import { MultiplesHelper } from "app/helpers/multiplesHelper";
import { UserType } from "app/types/userType";
import {
  BetslipListTypes,
  BetslipPanelTypes,
  BetSlipStates,
  PollingIntervals,
  ResponsiveScreenSizes,
} from "app/utils/const";
import cx from "classnames";
import { differenceBy, get, isEmpty } from "lodash";
import { Component, ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import Media from "react-media";
import { connect } from "react-redux";
import "./BetDrawerScreen.scss";
import BetDrawerHeaderDesktop from "./components/BetDrawerHeaderDesktop/BetDrawerHeaderDesktop";
import BetSlipLists from "./components/BetSlipLists/BetSlipLists";
import BetSlipTypesHeader from "./components/BetSlipTypesHeader/BetSlipTypesHeader";
import MobileDefaultBetSlipPanelSettings from "./components/MobileDefaultBetSlipPanelSettings/MobileDefaultBetSlipPanelSettings";
import OpenBetsList from "./components/OpenBetsList/OpenBetsList";
import PositionMatricesContent from "./components/PositionMatricesContent/PositionMatricesContent";

import type { BetSlipType } from "app/types/betSlipType";
import type { MultiplesBetSlipType } from "app/types/multiplesBetSlipType";
import type { PositionMatrixType } from "app/types/positionMatrixType";

type Props = {
  history: any;
  betSlipList: BetSlipType[];
  MultiplesBetSlip: MultiplesBetSlipType[];
  purgeBetSlipList: (...args: Array<any>) => any;
  toggleBetslipOpenBets: (...args: Array<any>) => any;
  currentBetsCount: number;
  currentOpenPositionsCount: number;
  loadReports: (...args: Array<any>) => any;
  loadCurrentBetsCount: (...args: Array<any>) => any;
  loadProcessingBets: (...args: Array<any>) => any;
  isReportListLoading: boolean;
  positionMatrixList: PositionMatrixType[];
  isPositionMatrixListLoading: boolean;
  loadPositionMatrixList: (...args: Array<any>) => any;
  removeFinishedBets: (...args: Array<any>) => any;
  removeAllRunners: (...args: Array<any>) => any;
  setFlashFlag: (...args: Array<any>) => any;
  isOrangeFlashActive: boolean;
  betslipFull: any;
  updateSingleBetSlipPrices: (...args: Array<any>) => any;
  updateMultipleBetSlipPrices: (...args: Array<any>) => any;
  user: UserType;
  multiplesBetSlipListStatus: string;
  clearMultiples: Function;
  isWebsocketReady: boolean;
  isPageVisible: Boolean;
  multiplesBetSlipList: MultiplesBetSlipType[];
  validateMultiples: Function;
};
type State = {
  intervalId: any;
  intervalStarted: boolean;
  betSlipAdded: boolean;
  betslipPanelTypes: string;
  positionMatrixOpen: boolean;
  positionMatrixModalEvent: any;
  pricesPollingIntervalId: any;
  pricesPollingIntervalStarted: boolean;
  multiplierPricesPollingIntervalId: any;
  multiplierPricesPollingIntervalStarted: boolean;
  betSlipTypeTab: string;
};

class BetDrawerScreen extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      intervalId: null,
      intervalStarted: false,
      betSlipAdded: false,
      betslipPanelTypes: BetslipPanelTypes.BETSLIP,
      positionMatrixOpen: false,
      positionMatrixModalEvent: null,
      pricesPollingIntervalId: null,
      multiplierPricesPollingIntervalId: null,
      pricesPollingIntervalStarted: false,
      multiplierPricesPollingIntervalStarted: false,
      betSlipTypeTab: BetslipListTypes.SINGLES,
    };
    this.props.loadProcessingBets();
    // BET-5979 remove finished bets
    this.props.removeFinishedBets();
  }

  toggleBetslipOpenBets = (tabType: string) => {
    if (tabType === BetslipPanelTypes.BETSLIP) {
      this.setState({
        betslipPanelTypes: BetslipPanelTypes.BETSLIP,
      });
      this.props.loadCurrentBetsCount();
      // BET-5979 remove finished bets
      this.props.removeFinishedBets();
      this.endIntervalFetchEvent();
    } else if (tabType === BetslipPanelTypes.OPENBETS) {
      this.setState({
        betslipPanelTypes: BetslipPanelTypes.OPENBETS,
      });
      this.startIntervalFetchEvent();
    } else if (tabType === BetslipPanelTypes.OPENPOSITIONS) {
      this.setState({
        betslipPanelTypes: BetslipPanelTypes.OPENPOSITIONS,
      });
      this.props.loadPositionMatrixList();
    }
  };

  /**
   * update event every 30 sec
   */
  startIntervalFetchEvent = () => {
    if (!this.state.intervalStarted) {
      const intervalId = setInterval(() => {
        // BET-5979 remove finished bets
        this.props.removeFinishedBets();
      }, PollingIntervals.OPEN_BETS_PANEL);
      this.setState({
        intervalId,
        intervalStarted: true,
      });
    }
  };
  startPollingForPrices = () => {
    const pollingInterval = this.props.isWebsocketReady
      ? PollingIntervals.BETSLIP_PRICE_POLLING
      : PollingIntervals.BETSLIP_PRICE_POLLING_FAST;
    if (!this.state.pricesPollingIntervalStarted) {
      this.fetchPricesForRunnersInBetslip();
      const pricesPollingIntervalId = setInterval(() => {
        this.fetchPricesForRunnersInBetslip();
      }, pollingInterval);
      this.setState({
        pricesPollingIntervalId,
        pricesPollingIntervalStarted: true,
      });
    }
  };
  startPollingForMultiplierPrices = () => {
    const pollingInterval = PollingIntervals.BETSLIP_PRICE_POLLING_FAST;
    if (!this.state.multiplierPricesPollingIntervalStarted) {
      this.fetchMultiplePricesForRunnersInBetslip();
      const multiplierPricesPollingIntervalId = setInterval(() => {
        this.fetchMultiplePricesForRunnersInBetslip();
      }, pollingInterval);
      this.setState({
        multiplierPricesPollingIntervalId,
        multiplierPricesPollingIntervalStarted: true,
      });
    }
  };
  endIntervalFetchEvent = () => {
    clearInterval(this.state.intervalId);
    this.setState({
      intervalStarted: false,
    });
  };

  endPollingForPrices = () => {
    clearInterval(this.state.pricesPollingIntervalId);
    this.setState({
      pricesPollingIntervalStarted: false,
    });
  };
  endPollingForMultiplierPrices = () => {
    clearInterval(this.state.multiplierPricesPollingIntervalId);
    this.setState({
      multiplierPricesPollingIntervalStarted: false,
    });
  };
  fetchPricesForRunnersInBetslip = () => {
    if (
      isEmpty(this.props.betSlipList) ||
      this.state.betSlipTypeTab === BetslipListTypes.MULTIPLES
    ) {
      return;
    }
    runnersApi
      .getPricesForRunnersInBetslip()
      .then(resp => {
        this.props.updateSingleBetSlipPrices(resp);
      })
      .catch(error => {
        throw error;
      });
  };

  /*
    the issue we faced here is the response from the api and the multiplesBetSlipList would not match 
    ie 3 runners added, 2 of them would have adjusted odds the 3rd would not.
    this lead to incorrect odds being displayed. to combat this:

    we added a promise with a delay of 100 ms so that multiplesBetSlipList is updated correctly,

    opted for this approach as initially we tried adding a check, to wait for 
    ‘validateMultiples’ to return before making the API call to fetch prices, 
    however this was not working and would often lead to long wait times if 
    an incorrect odd was shown. 
  */
  fetchMultiplePricesForRunnersInBetslip = async () => {
    if (
      isEmpty(this.props.multiplesBetSlipList) ||
      this.props.multiplesBetSlipListStatus === BetSlipStates.FINISHED ||
      this.state.betSlipTypeTab === BetslipListTypes.SINGLES
    ) {
      return;
    }

    // Introduce a short delay to allow the bet slip to be updated
    await new Promise(resolve => setTimeout(resolve, 100));

    try {
      // Fetch prices for multiple runners in the bet slip asynchronously
      const resp = await runnersApi.getPricesForMultiplesRunnersInBetslip();

      // Update multiple bet slip prices with the fetched prices
      this.props.updateMultipleBetSlipPrices(resp);

      // Validate the multiples after prices are fetched
      await this.props.validateMultiples();
    } catch (error) {
      // Log any errors that occur during fetching or updating
      console.error(
        "Error occurred while fetching prices for multiples:",
        error
      );
    }
  };

  componentDidMount() {
    if (this.state.betSlipTypeTab === BetslipListTypes.SINGLES) {
      this.startPollingForPrices();
    } else {
      this.startPollingForMultiplierPrices();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const prevOddsType = get(prevProps, ["user", "preferences", "oddsType"]);
    const oddsType = get(this.props, ["user", "preferences", "oddsType"]);

    const {
      betSlipList,
      isWebsocketReady,
      multiplesBetSlipList,
      validateMultiples,
    } = this.props;
    const betAddedToBetslip =
      prevProps.betSlipList &&
      prevProps.betSlipList.length < this.props.betSlipList.length;

    if (betAddedToBetslip) {
      let betAdded = differenceBy(
        betSlipList,
        prevProps.betSlipList,
        "localId"
      );
      if (!isEmpty(betAdded)) {
        MultiplesHelper.checkIfMultiplesEnabled(betAdded[0]);
        setTimeout(() => {
          // Make sure validation is run only after the price fetching is done
          this.fetchMultiplePricesForRunnersInBetslip();
        }, 250);
      }
    }
    if (this.state.betSlipTypeTab !== prevState.betSlipTypeTab) {
      if (this.state.betSlipTypeTab === BetslipListTypes.MULTIPLES) {
        this.endPollingForMultiplierPrices();
        this.startPollingForMultiplierPrices();
      } else {
        this.endPollingForMultiplierPrices();
      }
      if (this.state.betSlipTypeTab === BetslipListTypes.SINGLES) {
        this.endPollingForPrices();
        this.startPollingForPrices();
      } else {
        this.endPollingForPrices();
      }
    }
  }

  componentWillUnmount() {
    // Clear interval for fetching open bets
    this.endIntervalFetchEvent();
    this.endPollingForPrices();
    this.endPollingForMultiplierPrices();
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    // reportsList has not changed do not render unless
    if (this.state.betslipPanelTypes === "Open Bets") {
      // BET-3200 not very nice solution
      if (nextProps.betSlipList.length > this.props.betSlipList.length) {
        return true;
      } else if (nextState.betslipPanelTypes !== this.state.betslipPanelTypes)
        return true;
      else if (nextProps.currentBetsCount !== this.props.currentBetsCount) {
        return true;
      }

      this.props.loadCurrentBetsCount();
      return false;
    }

    return true;
  };

  resetAnimation() {
    this.props.setFlashFlag();
  }

  restartPollingForPrices = async () => {
    console.log("restartPollingForPrices");
    await this.endPollingForPrices();
    this.startPollingForPrices();
  };

  setBetSlipTypeTab = (tabType: string) => {
    const { multiplesBetSlipListStatus, clearMultiples } = this.props;
    if (this.state.betSlipTypeTab === tabType) {
      return null;
    }
    // reset multiples when switching to SINGLES tab
    if (multiplesBetSlipListStatus === "FINISHED" && tabType === "SINGLES") {
      // remove corresponsing single bets from bet slip panel
      MultiplesHelper.removeCorrespondingSingleBets();
      clearMultiples();
    }

    this.setState({
      betSlipTypeTab: tabType,
    });
  };

  render() {
    const { history, betSlipList, betslipFull } = this.props;
    const betSlipCount = betSlipList.filter(
      betSlip => betSlip.state !== BetSlipStates.FINISHED
    ).length;
    let content: ReactElement | null = null;

    switch (this.state.betslipPanelTypes) {
      case BetslipPanelTypes.BETSLIP:
        content = (
          <BetSlipLists
            betSlipList={betSlipList}
            tab={this.state.betSlipTypeTab}
          />
        );
        break;

      case BetslipPanelTypes.OPENBETS:
        content = <OpenBetsList />;
        break;

      case BetslipPanelTypes.OPENPOSITIONS:
        content = (
          <div className="bet-drawer__content">
            <PositionMatricesContent
              positionMatrixList={this.props.positionMatrixList}
              isPositionMatrixListLoading={
                this.props.isPositionMatrixListLoading
              }
            />
          </div>
        );
        break;

      default:
        content = null;
        break;
    }

    return (
      <div className="bet-drawer">
        <div className="bet-drawer__header">
          {/* desktop: render bet drawer desktop header */}
          <Media
            query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
            render={() => (
              <>
                <BetDrawerHeaderDesktop
                  betSlipCount={betSlipCount}
                  props={this.props}
                  toggleBetslipOpenBets={this.toggleBetslipOpenBets}
                  betslipPanelTypes={this.state.betslipPanelTypes}
                  currentBetsCount={this.props.currentBetsCount}
                  currentOpenPositionsCount={
                    this.props.currentOpenPositionsCount
                  }
                  setBetSlipTypeTab={this.setBetSlipTypeTab}
                  betSlipTypeTab={this.state.betSlipTypeTab}
                />
              </>
            )}
          />
          {/* mobile: render bet drawer mobile header with back button */}
          <Media
            query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
            render={() => (
              <>
                <BackButton history={history} mobile={true} />
                <MobileDefaultBetSlipPanelSettings />
                <div className="bet-drawer__header__title">
                  <IconBetDrawer className="bet-drawer__header__drawer-icon" />
                  <div>
                    <FormattedMessage tagName="span" id="bets-betslip-button" />{" "}
                    ({betSlipCount})
                  </div>
                </div>
                {betslipFull && (
                  <div className="bet-drawer__betslip-full">
                    <span
                      className={cx({
                        orangeFlash: this.props.isOrangeFlashActive,
                      })}
                      onAnimationEnd={() => this.resetAnimation()}
                    >
                      <FormattedMessage tagName="span" id="bets-betslip-full" />
                    </span>
                  </div>
                )}
              </>
            )}
          />
        </div>
        <div className="bet-drawer__content">
          {this.props.user["multiplierFeatureEnabled"] &&
            this.props.user.multipleBetAllowed && (
              <Media
                query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
                render={() => (
                  <BetSlipTypesHeader
                    setTab={this.setBetSlipTypeTab}
                    tab={this.state.betSlipTypeTab}
                  />
                )}
              />
            )}
          {content}
        </div>
        <Media
          query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
          render={() => <ScrollToTop />}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  betSlipList: state.betSlipListModel.betSlipList,
  currentBetsCount: state.betSlipListModel.currentBetsCount,
  currentOpenPositionsCount: state.positionMatrixListModel.total,
  positionMatrixList: state.positionMatrixListModel.positionMatrixList,
  isPositionMatrixListLoading:
    state.positionMatrixListModel.isPositionMatrixListLoading,
  betslipFull: state.betSlipListModel.betslipFull,
  isOrangeFlashActive: state.betSlipListModel.isOrangeFlashActive,
  user: state.userModel.user,
  multiplesBetSlipListStatus: state.multiplesBetSlipListModel.status,
  isWebsocketReady: state.subscribeModel.isWebsocketReady,
  reconnecting: state.subscribeModel.reconnecting,
  isPageVisible: state.sessionModel.isPageVisible,
  multiplesBetSlipList: state.multiplesBetSlipListModel.multiplesBetSlipList,
  isReportListLoading: state.openBetsListModel.isReportListLoading,
});

const mapDispatchToProps = dispatch => ({
  loadProcessingBets: () => dispatch.betSlipListModel.loadProcessingBets(),
  loadCurrentBetsCount: () => dispatch.betSlipListModel.loadCurrentBetsCount(),
  loadPositionMatrixList: () =>
    dispatch.positionMatrixListModel.setPositionMatrixList(),
  removeFinishedBets: () => dispatch.betSlipListModel.removeFinishedBets(),
  setFlashFlag: () => dispatch.betSlipListModel.setFlashFlag(),
  updateSingleBetSlipPrices: resp => {
    dispatch.betSlipListModel.updateSingleBetSlipPrices(resp);
    dispatch.multiplesBetSlipListModel.updateLegOddsFromPricesFetch(resp);
  },
  updateMultipleBetSlipPrices: resp => {
    dispatch.multiplesBetSlipListModel.updateMultipleBetSlipPrices(resp);
    dispatch.multiplesBetSlipListModel.updateLegOddsFromPricesFetch(resp);
    dispatch.betBuilderModel.updatePricesFromPoll(resp);
  },
  clearMultiples: () => {
    dispatch.multiplesBetSlipListModel.clearMultiples();
  },
  validateMultiples: () =>
    dispatch.multiplesBetSlipListModel.validateMultiples(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BetDrawerScreen) as any;
